import { render, staticRenderFns } from "./Policies.vue?vue&type=template&id=6b685ecc&"
import script from "./Policies.vue?vue&type=script&lang=ts&"
export * from "./Policies.vue?vue&type=script&lang=ts&"
import style0 from "./Policies.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports